import React from 'react';
import PropTypes from 'prop-types';
import { LogoTiny } from '../Logo';
import Body from './Body';

const InfoBody = ({ msg }) => (
  <Body msg={msg}>
    <LogoTiny minWidth={26} height={32} color="#1b305c" />
  </Body>
);

InfoBody.propTypes = {
  msg: PropTypes.string.isRequired
};

export default InfoBody;
